import { Route, Routes } from 'react-router-dom';

import NotFound from '../screens/Auth/NotFound';
import WebStoreEnterPurchaseClubScreen from '../screens/WebStore/WebStoreEnterPurchaseClub';
import WebStoreProductDetailScreen from '../screens/WebStore/WebStoreProductDetail';
import WebStoreProductListScreen from '../screens/WebStore/WebStoreProductList';
import WebStoreProductRedemptionScreen from '../screens/WebStore/WebStoreProductRedemption';
import WebStoreProductSelectVersionScreen from '../screens/WebStore/WebStoreProductSelectVersion';
import WebStoreReferralRewardScreen from '../screens/WebStore/WebStoreReferralReward';
import WebStoreReferralRewardDetailScreen from '../screens/WebStore/WebStoreReferralRewardDetail';
import WebStoreReferralRewardTier0Screen from '../screens/WebStore/WebStoreReferralRewardTier0';
import WebStoreReferralRewardTier1Screen from '../screens/WebStore/WebStoreReferralRewardTier1';
import WebStoreReferralRewardTier2Screen from '../screens/WebStore/WebStoreReferralRewardTier2';
import WebStoreReferralUserListScreen from '../screens/WebStore/WebStoreReferralUserList';
import WebStoreRoleDetailScreen from '../screens/WebStore/WebStoreRoleDetail';

const WebProductRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<WebStoreProductListScreen />} />
      <Route path="/role" element={<WebStoreRoleDetailScreen />} />
      <Route path="/:rewardOfferId" element={<WebStoreProductDetailScreen />} />
      <Route
        path="/:rewardOfferId/select-version"
        element={<WebStoreProductSelectVersionScreen />}
      />
      <Route
        path="/:rewardOfferId/enter-purchased-club"
        element={<WebStoreEnterPurchaseClubScreen />}
      />
      <Route
        path="/:rewardOfferId/rewardRedemption/:rewardRedemptionId"
        element={<WebStoreProductRedemptionScreen />}
      />
      <Route path="/referral" element={<WebStoreReferralRewardScreen />} />
      <Route
        path="/referral/:role"
        element={<WebStoreReferralUserListScreen />}
      />
      <Route
        path="/referral/customer/:customerId1"
        element={<WebStoreReferralRewardTier1Screen />}
      />
      <Route
        path="/referral/customer/:customerId1/:customerId2"
        element={<WebStoreReferralRewardTier2Screen />}
      />
      <Route
        path="/referral/distributor/:distributorId"
        element={<WebStoreReferralRewardTier0Screen />}
      />
      <Route
        path="/referral/distributor/:distributorId/:customerId1"
        element={<WebStoreReferralRewardTier1Screen />}
      />
      <Route
        path="/referral/distributor/:distributorId/:customerId1/:customerId2"
        element={<WebStoreReferralRewardTier2Screen />}
      />
      <Route
        path="/referral/customer/detail"
        element={<WebStoreReferralRewardDetailScreen />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default WebProductRoute;
